import React from 'react';

const csrfToken = (selector) => {
    const token = document.head.querySelector(selector);

    if (token) {
        return token.content;
    }

    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
};

const CsrfField = ({selector}) => (
    <input
        type="hidden"
        name="_token"
        value={csrfToken(selector)}
    />
);

CsrfField.defaultProps = {
    selector: 'meta[name="csrf-token"]',
};

export default CsrfField;


// WEBPACK FOOTER //
// ./resources/assets/js/components/Form/CsrfField.jsx